import React, { Component } from 'react';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import {
  Col,
  Container,
  Row } from 'reactstrap';

import Method from './Method';
import ListText from './ListText';
import ListCall from './ListCall';
import Code from './Code';

class DTC2faMethod extends Component {
  render() {
    return (
      <Router>
        <div className="page-preapproved narrow">
          <Container>
            <Row className="justify-content-center">
              <Col md={8} lg={6} className="text-center mb-4 mt-2 mt-md-4 pb-1">

                <img src="/icons/2fa-shield.svg" alt="Two-step Verification" className="mb-3" />
                <h2 className="mb-1">Two-step Verification</h2>
                <p className="mb-4">For your security, we need to send you a verification code.</p>

                <Row className="pt-1 justify-content-center">
                  <Col sm={12} md={10} xl={9}>
                    <Route exact path="/dtc/2fa" component={Method} />
                    <Route exact path="/dtc/2fa/text" component={ListText} />
                    <Route exact path="/dtc/2fa/call" component={ListCall} />
                    <Route exact path="/dtc/2fa/code" component={Code} />
                  </Col>
                </Row>

              </Col>
            </Row>
          </Container>
        </div>
      </Router>
    )
  }
}

export default DTC2faMethod;
